export var FixedBlockType;
(function (FixedBlockType) {
    //run
    FixedBlockType["if_run"] = "if_run";
    FixedBlockType["linear"] = "linear";
    FixedBlockType["loop"] = "loop";
    FixedBlockType["schedule_run"] = "schedule_run";
    //logic
    FixedBlockType["and"] = "and";
    FixedBlockType["or"] = "or";
    FixedBlockType["not"] = "not";
    FixedBlockType["if_then"] = "if_then";
    FixedBlockType["if_then_else"] = "if_then_else";
    FixedBlockType["numeric_comparator"] = "numeric_comparator";
    FixedBlockType["sensor_comparator"] = "sensor_comparator";
    //reactions
    FixedBlockType["do_notification"] = "do_notification";
    FixedBlockType["do_output_action"] = "do_output_action";
    FixedBlockType["do_pump"] = "do_pump";
    FixedBlockType["do_relay"] = "do_relay";
    FixedBlockType["set_guard"] = "set_guard";
    FixedBlockType["do_buzzer"] = "do_buzzer";
    FixedBlockType["do_tap"] = "do_tap";
    FixedBlockType["do_temperature_in_circuit"] = "do_temperature_in_circuit";
    FixedBlockType["pause"] = "pause";
    FixedBlockType["do_scenario"] = "do_scenario";
    FixedBlockType["do_return"] = "do_return";
    FixedBlockType["do_break"] = "do_break";
    FixedBlockType["do_continue"] = "do_continue";
    //sensor
    FixedBlockType["analog_input"] = "analog_input";
    FixedBlockType["radio_input"] = "radio_input";
    FixedBlockType["temperature_input"] = "temperature_input";
    //activate-heating-modes
    FixedBlockType["do_heat_mode_for_heat_circuit"] = "do_heat_mode_for_heat_circuit";
    //sensor-states Состояние датчиков (bool)
    FixedBlockType["analog_input_state"] = "analog_input_state";
    FixedBlockType["analog_temperature_sensor_state"] = "analog_temperature_sensor_state";
    FixedBlockType["state_heat_mode_for_heat_circuit"] = "state_heat_mode_for_heat_circuit";
    FixedBlockType["guard_state"] = "guard_state";
    FixedBlockType["pump_state"] = "pump_state";
    FixedBlockType["radio_sensor_state"] = "radio_sensor_state";
    FixedBlockType["humidity_radio_sensor_state"] = "humidity_radio_sensor_state";
    FixedBlockType["radio_sensor_433_state"] = "radio_sensor_433_state";
    FixedBlockType["relay_state"] = "relay_state";
    FixedBlockType["buzzer_state"] = "buzzer_state";
    FixedBlockType["tap_state"] = "tap_state";
    FixedBlockType["wired_temperature_sensor_state"] = "wired_temperature_sensor_state";
    FixedBlockType["boiler_adapter"] = "boiler_adapter";
    //time
    FixedBlockType["time_comparator"] = "time_comparator";
    FixedBlockType["weekdays_input"] = "weekdays_input";
})(FixedBlockType || (FixedBlockType = {}));
